import styled from "styled-components"
import { media } from "utils/utils"

export const Container = styled.div`
  width: ${props =>
    props.fullwidth
      ? "100%"
      : props.narrow
      ? "480px"
      : props.large
      ? "1144px"
      : props.xLarge
      ? "1180px"
      : props.medium
      ? "752px"
      : "912px"};
  max-width: 100%;
  margin: ${props => (props.margin ? props.margin : "0 auto")};

  ${media.md`
    width: 100%;
    // padding: ${props => (props.noPadding ? 0 : "0 10px;")}
  `};
`
